import { render, staticRenderFns } from "./ReportMinimal.vue?vue&type=template&id=599066a1&scoped=true&"
import script from "./ReportMinimal.vue?vue&type=script&lang=js&"
export * from "./ReportMinimal.vue?vue&type=script&lang=js&"
import style0 from "./ReportMinimal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReportMinimal.vue?vue&type=style&index=1&id=599066a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599066a1",
  null
  
)

export default component.exports
import {QBtn,QTooltip,QItem,QInput,QCheckbox,QExpansionItem,QItemSection,QCardActions} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QItem,QInput,QCheckbox,QExpansionItem,QItemSection,QCardActions}, component.options.components || {})
